import { useOpen, useWidth, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowStore } from "../../../../../store";
import { Box, Chip, Grid, Typography } from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const Contenedor = () => {
  const widthFull = useWidth();

  return (
    <>
      <Box sx={{ width: "100%", bgcolor: "#A9A9A9", padding:"5px 15px 5px 15px" }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            margin: "auto 0px",
            color: "white",
            fontWeight: "bold",
            fontSize: 12,
          }}
        >
          ESTRUCTURA EXTERIOR DEL CONTENEDOR
        </Typography>
      </Box>
      <Grid
        container
        justifyContent="flex-start"
        alignContent="flex-start"
        alignItems="flex-start"
        spacing={0}
        sx={{ bgcolor: "white" }}
      >
        <Grid item xs={12} sx={{ m: 1 }}>
          <Chip
            color="success"
            label="EXTERIOR ESTRUCTURA"
            sx={{ borderRadius: 1 }}
          />
        </Grid>
        <Grid item xs={5} sx={{ m: 1 }}>
          <ParedExternaLadoDerecho widthFull={widthFull} />
        </Grid>
        <Grid item xs={5} sx={{ m: 1 }}>
          <ParedExternaLadoIzquierdo widthFull={widthFull} />
        </Grid>
        <Grid item xs={5} sx={{ m: 1 }}>
          <PanelExterior widthFull={widthFull} />
        </Grid>
        <Grid item xs={5} sx={{ m: 1 }}>
          <TechoExterior widthFull={widthFull} />
        </Grid>
        <Grid item xs={5} sx={{ m: 1 }}>
          <PisoIzquierdoExterior widthFull={widthFull} />
        </Grid>
        <Grid item xs={5} sx={{ m: 1 }}>
          <PisoDerechoExterior widthFull={widthFull} />
        </Grid>
        <Grid item xs={12} sx={{ mt: 1, mb: 1 }}>
          <Grid
            container
            sx={{
              borderTop: "1px dashed darkgreen",
              pt: 6,
              pb: 1,
              position: "relative",
            }}
          >
            <Chip
              color="success"
              label="PARCHES EXTERIOR"
              sx={{ borderRadius: 1, position: "absolute", top: 5, left: 7 }}
            />

            <Grid item xs={5} sx={{ m: 1 }}>
              <ParcheExteriorPhoto widthFull={widthFull} />
            </Grid>
            <Grid item xs={5} sx={{ m: 1 }}>
              <ParcheExteriorPhoto2 widthFull={widthFull} />
            </Grid>
            <Grid item xs={5} sx={{ m: 1 }}>
              <ParcheExteriorPhoto3 widthFull={widthFull} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box sx={{ width: "100%", bgcolor: "#A9A9A9", padding:"5px 15px 5px 15px" }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            margin: "auto 0px",
            color: "white",
            fontWeight: "bold",
            fontSize: 12,
          }}
        >
          ESTRUCTURA INTERIOR DEL CONTENEDOR
        </Typography>
      </Box>
      <Grid
        container
        justifyContent="flex-start"
        alignContent="flex-start"
        alignItems="flex-start"
        spacing={0}
        sx={{ bgcolor: "white" }}
      >
        <Grid item xs={12} sx={{ m: 1 }}>
          <Chip
            color="success"
            label="INTERIOR ESTRUCTURA"
            sx={{ borderRadius: 1 }}
          />
        </Grid>
        <Grid item xs={5} sx={{ m: 1 }}>
          <ParedInternaDerecha widthFull={widthFull} />
        </Grid>
        <Grid item xs={5} sx={{ m: 1 }}>
          <ParedInternaIzquierda widthFull={widthFull} />
        </Grid>
        <Grid item xs={5} sx={{ m: 1 }}>
          <PisoInterno widthFull={widthFull} />
        </Grid>
        <Grid item xs={5} sx={{ m: 1 }}>
          <TechoInterno widthFull={widthFull} />
        </Grid>
        <Grid item xs={12} sx={{ mt: 1, mb: 1 }}>
          <Grid
            container
            spacing={0}
            sx={{
              borderTop: "1px dashed darkgreen",
              pt: 6,
              pb: 1,
              position: "relative",
            }}
          >
            <Chip
              color="success"
              label="DUCTOS"
              sx={{ borderRadius: 1, position: "absolute", top: 5, left: 7 }}
            />
            <Grid item xs={5} sx={{ m: 1 }}>
              <PanelInternoPhoto widthFull={widthFull} />
            </Grid>
            <Grid item xs={5} sx={{ m: 1 }}>
              <PanelInternoPhoto2 widthFull={widthFull} />
            </Grid>
            <Grid item xs={5} sx={{ m: 1 }}>
              <PanelInternoPhoto3 widthFull={widthFull} />
            </Grid>
            <Grid item xs={5} sx={{ m: 1 }}>
              <PanelInternoPhoto4 widthFull={widthFull} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ mt: 1, mb: 1 }}>
          <Grid
            container
            spacing={0}
            sx={{
              borderTop: "1px dashed darkgreen",
              pt: 6,
              pb: 1,
              position: "relative",
            }}
          >
            <Chip
              color="success"
              label="PARCHES INTERIOR"
              sx={{ borderRadius: 1, position: "absolute", top: 5, left: 7 }}
            />
            <Grid item xs={5} sx={{ m: 1 }}>
              <ParcheInteriorPhoto widthFull={widthFull} />
            </Grid>
            <Grid item xs={5} sx={{ m: 1 }}>
              <ParcheInteriorPhoto2 widthFull={widthFull} />
            </Grid>
            <Grid item xs={5} sx={{ m: 1 }}>
              <ParcheInteriorPhoto3 widthFull={widthFull} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

//EXTERIOR ESTRUCTURA

const ParedExternaLadoDerecho = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPaExtDe,
    handleClose: handleClosePaExtDe,
    handleOpen: handleOpenPaExtDe,
  } = useOpen();

  const paredExternaLadoDerechoPhoto = useWorkflowStore(
    (state) => state.paredExternaLadoDerechoPhoto
  );

  const setParedExternaLadoDerechoPhoto = useWorkflowStore(
    (state) => state.setParedExternaLadoDerechoPhoto
  );
  const fotoUrl = useBlobUrl(paredExternaLadoDerechoPhoto);

  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePaExtDe}
      handleOpen={handleOpenPaExtDe}
      label="PARED LADO DERECHO"
      open={openPaExtDe}
      setFoto={setParedExternaLadoDerechoPhoto}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const ParedExternaLadoIzquierdo = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPaExtIz,
    handleClose: handleClosePaExtIz,
    handleOpen: handleOpenPaExtIz,
  } = useOpen();

  const paredExternaLadoIzquierdoPhoto = useWorkflowStore(
    (state) => state.paredExternaLadoIzquierdoPhoto
  );

  const setParedExternaLadoIzquierdoPhoto = useWorkflowStore(
    (state) => state.setParedExternaLadoIzquierdoPhoto
  );
  const fotoUrl = useBlobUrl(paredExternaLadoIzquierdoPhoto);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePaExtIz}
      handleOpen={handleOpenPaExtIz}
      label="PARED LADO IZQUIERDO"
      open={openPaExtIz}
      setFoto={setParedExternaLadoIzquierdoPhoto}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const PanelExterior = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPaExt,
    handleClose: handleClosePaExt,
    handleOpen: handleOpenPaExt,
  } = useOpen();

  const setPanelExteriorPhoto = useWorkflowStore(
    (state) => state.setPanelExteriorPhoto
  );

  const panelExteriorPhoto = useWorkflowStore(
    (state) => state.panelExteriorPhoto
  );
  const fotoUrl = useBlobUrl(panelExteriorPhoto);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePaExt}
      handleOpen={handleOpenPaExt}
      label="PANEL"
      open={openPaExt}
      setFoto={setPanelExteriorPhoto}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const TechoExterior = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openTeExt,
    handleClose: handleCloseTeExt,
    handleOpen: handleOpenTeExt,
  } = useOpen();

  const techoExteriorPhoto = useWorkflowStore(
    (state) => state.techoExteriorPhoto
  );

  const setTechoExteriorPhoto = useWorkflowStore(
    (state) => state.setTechoExteriorPhoto
  );
  const fotoUrl = useBlobUrl(techoExteriorPhoto);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseTeExt}
      handleOpen={handleOpenTeExt}
      label="TECHO"
      open={openTeExt}
      setFoto={setTechoExteriorPhoto}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const PisoIzquierdoExterior = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPisExt,
    handleClose: handleClosePisExt,
    handleOpen: handleOpenPisExt,
  } = useOpen();

  const pisoIzquierdoExteriorPhoto = useWorkflowStore(
    (state) => state.pisoIzquierdoExteriorPhoto
  );

  const setPisoIzquierdoExteriorPhoto = useWorkflowStore(
    (state) => state.setPisoIzquierdoExteriorPhoto
  );
  const fotoUrl = useBlobUrl(pisoIzquierdoExteriorPhoto);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePisExt}
      handleOpen={handleOpenPisExt}
      label="PISO IZQUIERDO"
      open={openPisExt}
      setFoto={setPisoIzquierdoExteriorPhoto}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const PisoDerechoExterior = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPisExt,
    handleClose: handleClosePisExt,
    handleOpen: handleOpenPisExt,
  } = useOpen();

  const pisoDerechoExteriorPhoto = useWorkflowStore(
    (state) => state.pisoDerechoExteriorPhoto
  );

  const setPisoDerechoExteriorPhoto = useWorkflowStore(
    (state) => state.setPisoDerechoExteriorPhoto
  );
  const fotoUrl = useBlobUrl(pisoDerechoExteriorPhoto);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePisExt}
      handleOpen={handleOpenPisExt}
      label="PISO DERECHO"
      open={openPisExt}
      setFoto={setPisoDerechoExteriorPhoto}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

//PARCHES EXTERIOR

const ParcheExteriorPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openExtParche1,
    handleClose: handleCloseExtParche1,
    handleOpen: handleOpenExtParche1,
  } = useOpen();

  const parchesExtPhoto1 = useWorkflowStore((state) => state.parchesExtPhoto1);

  const setParchesExtPhoto1 = useWorkflowStore(
    (state) => state.setParchesExtPhoto1
  );
  const fotoUrl = useBlobUrl(parchesExtPhoto1);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseExtParche1}
      handleOpen={handleOpenExtParche1}
      label="FOTO 1"
      open={openExtParche1}
      setFoto={setParchesExtPhoto1}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const ParcheExteriorPhoto2 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openExtParche2,
    handleClose: handleCloseExtParche2,
    handleOpen: handleOpenExtParche2,
  } = useOpen();

  const parchesExtPhoto2 = useWorkflowStore((state) => state.parchesExtPhoto2);

  const setParchesExtPhoto2 = useWorkflowStore(
    (state) => state.setParchesExtPhoto2
  );
  const fotoUrl = useBlobUrl(parchesExtPhoto2);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseExtParche2}
      handleOpen={handleOpenExtParche2}
      label="FOTO 2"
      open={openExtParche2}
      setFoto={setParchesExtPhoto2}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const ParcheExteriorPhoto3 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openExtParche3,
    handleClose: handleCloseExtParche3,
    handleOpen: handleOpenExtParche3,
  } = useOpen();

  const parchesExtPhoto3 = useWorkflowStore((state) => state.parchesExtPhoto3);

  const setParchesExtPhoto3 = useWorkflowStore(
    (state) => state.setParchesExtPhoto3
  );
  const fotoUrl = useBlobUrl(parchesExtPhoto3);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseExtParche3}
      handleOpen={handleOpenExtParche3}
      label="FOTO 3"
      open={openExtParche3}
      setFoto={setParchesExtPhoto3}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

//INTERIOR ESTRUCTURA
const ParedInternaDerecha = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPaIntDe,
    handleClose: handleClosePaIntDe,
    handleOpen: handleOpenPaIntDe,
  } = useOpen();

  const paredInternaLadoDerechoPhoto = useWorkflowStore(
    (state) => state.paredInternaLadoDerechoPhoto
  );

  const setParedInternaLadoDerechoPhoto = useWorkflowStore(
    (state) => state.setParedInternaLadoDerechoPhoto
  );
  const fotoUrl = useBlobUrl(paredInternaLadoDerechoPhoto);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePaIntDe}
      handleOpen={handleOpenPaIntDe}
      label="PARED LADO DERECHO"
      open={openPaIntDe}
      setFoto={setParedInternaLadoDerechoPhoto}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const ParedInternaIzquierda = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPaIntIz,
    handleClose: handleClosePaIntIz,
    handleOpen: handleOpenPaIntIz,
  } = useOpen();

  const paredInternaLadoIzquierdoPhoto = useWorkflowStore(
    (state) => state.paredInternaLadoIzquierdoPhoto
  );

  const setParedInternaLadoIzquierdoPhoto = useWorkflowStore(
    (state) => state.setParedInternaLadoIzquierdoPhoto
  );
  const fotoUrl = useBlobUrl(paredInternaLadoIzquierdoPhoto);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePaIntIz}
      handleOpen={handleOpenPaIntIz}
      label="PARED LADO IZQUIERDO"
      open={openPaIntIz}
      setFoto={setParedInternaLadoIzquierdoPhoto}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const TechoInterno = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openTeInt,
    handleClose: handleCloseTeInt,
    handleOpen: handleOpenTeInt,
  } = useOpen();

  const techoInternoPhoto = useWorkflowStore(
    (state) => state.techoInternoPhoto
  );

  const setTechoInternoPhoto = useWorkflowStore(
    (state) => state.setTechoInternoPhoto
  );
  const fotoUrl = useBlobUrl(techoInternoPhoto);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseTeInt}
      handleOpen={handleOpenTeInt}
      label="TECHO"
      open={openTeInt}
      setFoto={setTechoInternoPhoto}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const PisoInterno = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPisInt,
    handleClose: handleClosePisInt,
    handleOpen: handleOpenPisInt,
  } = useOpen();

  const pisoInternoPhoto = useWorkflowStore((state) => state.pisoInternoPhoto);

  const setPisoInternoPhoto = useWorkflowStore(
    (state) => state.setPisoInternoPhoto
  );
  const fotoUrl = useBlobUrl(pisoInternoPhoto);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePisInt}
      handleOpen={handleOpenPisInt}
      label="PISO"
      open={openPisInt}
      setFoto={setPisoInternoPhoto}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

//PANEL INTERIOR
const PanelInternoPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPaInt1,
    handleClose: handleClosePaInt1,
    handleOpen: handleOpenPaInt1,
  } = useOpen();

  const panelInternoPhoto1 = useWorkflowStore(
    (state) => state.panelInternoPhoto1
  );

  const setPanelInternoPhoto1 = useWorkflowStore(
    (state) => state.setPanelInternoPhoto1
  );
  const fotoUrl = useBlobUrl(panelInternoPhoto1);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePaInt1}
      handleOpen={handleOpenPaInt1}
      label="DUCTO IZQUIERDO"
      open={openPaInt1}
      setFoto={setPanelInternoPhoto1}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const PanelInternoPhoto2 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPaInt2,
    handleClose: handleClosePaInt2,
    handleOpen: handleOpenPaInt2,
  } = useOpen();

  const panelInternoPhoto2 = useWorkflowStore(
    (state) => state.panelInternoPhoto2
  );
  const setPanelInternoPhoto2 = useWorkflowStore(
    (state) => state.setPanelInternoPhoto2
  );
  const fotoUrl = useBlobUrl(panelInternoPhoto2);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePaInt2}
      handleOpen={handleOpenPaInt2}
      label="DUCTO CENTRO"
      open={openPaInt2}
      setFoto={setPanelInternoPhoto2}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const PanelInternoPhoto3 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPaInt3,
    handleClose: handleClosePaInt3,
    handleOpen: handleOpenPaInt3,
  } = useOpen();

  const panelInternoPhoto3 = useWorkflowStore(
    (state) => state.panelInternoPhoto3
  );
  const setPanelInternoPhoto3 = useWorkflowStore(
    (state) => state.setPanelInternoPhoto3
  );
  const fotoUrl = useBlobUrl(panelInternoPhoto3);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePaInt3}
      handleOpen={handleOpenPaInt3}
      label="DUCTO DERECHO"
      open={openPaInt3}
      setFoto={setPanelInternoPhoto3}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const PanelInternoPhoto4 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openPaInt4,
    handleClose: handleClosePaInt4,
    handleOpen: handleOpenPaInt4,
  } = useOpen();

  const panelInternoPhoto4 = useWorkflowStore(
    (state) => state.panelInternoPhoto4
  );

  const setPanelInternoPhoto4 = useWorkflowStore(
    (state) => state.setPanelInternoPhoto4
  );
  const fotoUrl = useBlobUrl(panelInternoPhoto4);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleClosePaInt4}
      handleOpen={handleOpenPaInt4}
      label="DUCTO CENTRO 2"
      open={openPaInt4}
      setFoto={setPanelInternoPhoto4}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

//PARCHEs INTERIOR
const ParcheInteriorPhoto = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openParche1,
    handleClose: handleCloseParche1,
    handleOpen: handleOpenParche1,
  } = useOpen();

  const parchesPhoto1 = useWorkflowStore((state) => state.parchesPhoto1);
  const setParchesPhoto1 = useWorkflowStore((state) => state.setParchesPhoto1);
  const fotoUrl = useBlobUrl(parchesPhoto1);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseParche1}
      handleOpen={handleOpenParche1}
      label="FOTO 1"
      open={openParche1}
      setFoto={setParchesPhoto1}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const ParcheInteriorPhoto2 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openParche2,
    handleClose: handleCloseParche2,
    handleOpen: handleOpenParche2,
  } = useOpen();

  const parchesPhoto2 = useWorkflowStore((state) => state.parchesPhoto2);
  const setParchesPhoto2 = useWorkflowStore((state) => state.setParchesPhoto2);
  const fotoUrl = useBlobUrl(parchesPhoto2);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseParche2}
      handleOpen={handleOpenParche2}
      label="FOTO 2"
      open={openParche2}
      setFoto={setParchesPhoto2}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};

const ParcheInteriorPhoto3 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openParche3,
    handleClose: handleCloseParche3,
    handleOpen: handleOpenParche3,
  } = useOpen();

  const parchesPhoto3 = useWorkflowStore((state) => state.parchesPhoto3);
  const setParchesPhoto3 = useWorkflowStore((state) => state.setParchesPhoto3);
  const fotoUrl = useBlobUrl(parchesPhoto3);
  
  return (
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseParche3}
      handleOpen={handleOpenParche3}
      label="FOTO 3"
      open={openParche3}
      setFoto={setParchesPhoto3}
      width={widthFull === "xs" ? 50 : 130}
      fontSize={widthFull === "xs" ? 8 : 10}
    />
  );
};
